/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { unitToPixels, pixelsToUnit } from 'shared/libs/utils/numbers';
import InputWithUnit from 'shared/ui/components/form-components/InputWithUnit.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';

const __vue_script__ = {
    name: 'PositionControls',

    components: {
        ExpandableContent,
        InputWithUnit,
    },

    props: {
        left: {
            type: Number,
            required: true,
        },

        top: {
            type: Number,
            required: true,
        },

        pageDimensions: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            inputLeft: this.toUnit(this.left),
            inputTop: this.toUnit(this.top),
            currentFocus: null,
        };
    },

    watch: {
        pageDimensions() {
            this.inputLeft = this.toUnit(this.left);
            this.inputTop = this.toUnit(this.top);
        },
        left(value) {
            if (this.currentFocus !== 'left') {
                this.inputLeft = this.toUnit(value);
            }
        },
        top(value) {
            if (this.currentFocus !== 'top') {
                this.inputTop = this.toUnit(value);
            }
        }
    },

    methods: {
        /** @param {number} pixels */
        toUnit(pixels) {
            return pixelsToUnit(
                pixels,
                this.pageDimensions.dpi,
                this.pageDimensions.userUnit,
            );
        },
        handleInput(property, units) {
            if (!Number.isFinite(units)) {
                return;
            }
            const value = unitToPixels(
                units,
                this.pageDimensions.dpi,
                this.pageDimensions.userUnit,
            );
            this.$emit('change', { property, value });
        },
        handleFocus(property, event) {
            this.currentFocus = property;
            this.$emit('focus', event);
        },
        handleBlur(property, event) {
            this.currentFocus = null;
            this.$emit('blur', event);
            this.$nextTick(() => {
                if (property === 'left') {
                    this.inputLeft = this.toUnit(this.left);
                    return;
                }
                if (property === 'top') {
                    this.inputTop = this.toUnit(this.top);
                }
            });
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-controls"},[_c('template',{slot:"header"},[_c('h5',[_vm._v(_vm._s(_vm.$t('onsite_scanning.badge_editor.parameters.position')))])]),_c('div',{staticClass:"param-group"},[_c('input-with-unit',{attrs:{"type":"number","name":"x","value":_vm.inputLeft,"label":"X","step":0.25},on:{"input":function($event){return _vm.handleInput('left', $event)},"focus":function($event){return _vm.handleFocus('left', $event)},"blur":function($event){return _vm.handleBlur('left', $event)}}},[_c('span',[_vm._v(_vm._s(_vm.pageDimensions.userUnit))])]),_c('input-with-unit',{attrs:{"type":"number","name":"y","value":_vm.inputTop,"label":"Y","step":0.25},on:{"input":function($event){return _vm.handleInput('top', $event)},"focus":function($event){return _vm.handleFocus('top', $event)},"blur":function($event){return _vm.handleBlur('top', $event)}}},[_c('span',[_vm._v(_vm._s(_vm.pageDimensions.userUnit))])])],1)],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PositionControls.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__